import React from 'react'

export enum Features {
  RENOVATION_CLAUSE_DISPLAY = 'lawyer.renovation.clause.display',
  REQUEST_LETTER_LAWYER = 'lawyer.request.letter',
  LAWYER_DASHBOARD = 'lawyer.dashboard',
  LAWYER_TEXT_TEMPLATES = 'lawyer.text.templates',
  CUSTOMER_NOTE_IN_PROFILE_BOX = 'lawyer.customer.note.in.profile.box',
  UTILITY_BILL_AI_CHECK_IN_CHAT = 'lawyer.chat.show-utility-bill-ai',
  POWER_OF_ATTORNEY = 'lawyer.power-of-attorney.request',
  POWER_OF_ATTORNEY_DIGITAL = 'lawyer.power-of-attorney.digital',
  POWER_OF_ATTORNEY_PAPER = 'lawyer.power-of-attorney.paper',
  SUGGEST_APPOINTMENT = 'lawyer.suggest-appointment',
  COPY_NKA_RESULTS = 'lawyer.permission.copy-nka-results',
  COURT_CASE_BUTTON = 'lawyer.court-case.button',
  COURT_CASE_PROGRAM = 'lawyer.court-case.program',
  COURT_CASE_INVOICING = 'lawyer.court-case.invoicing'
}

export enum LoadingState {
  WAITING = 'WAITING',
  LOADING = 'LOADING',
  ERROR = 'ERROR',
  SUCCESS = 'SUCCESS'
}

export type FeatureConfig = {
  name: Features
  route?: boolean
  fallback?:
    | React.ComponentClass<any>
    | React.FunctionComponent<any>
    | string
    | React.ReactElement<any>
}

export type FeatureState = {
  loading: LoadingState
  features: {
    [key in Features]?: boolean
  }
}
